exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ctitle[data-v-380400fd]{height:56px;width:100%;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/newTeamList.vue"],"names":[],"mappings":"AACA,yBACE,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB","file":"newTeamList.vue","sourcesContent":["\n.ctitle[data-v-380400fd]{\n  height: 56px;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-380400fd","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/newTeamList.vue
// module id = 574
// module chunks = 6